export const environment = {
  production: false,
  env: 'stg',
  version: 'stg-81b690af',
  feedbackDelay: 5000,
  api: 'https://stg.api.roz.copec.cl',
  googleAnalyticsId: 'G-WZ7RJH83XV',
};
